/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

// index.tsx
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/app/assets/style.css";
import "../src/app/assets/style.css.map";
import "../src/app/assets/style.scss";
import "../src/app/assets/variables.css";
import "../src/app/assets/variables.css.map";
import "../src/app/assets/variables.scss";
import reportWebVitals from "./reportWebVitals";
import AppRoutes from "./app/routings/AppRoutes";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { SplashScreen } from "./app/features/SplashScreen";
import PlanProvider from "./app/modules/subscription/files/PlanContext";
import { ModalProvider } from "./app/modules/Context/ModalContext";
import { SubscriptionProvider } from "./app/modules/Context/SubscriptionContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const App: React.FC = () => {
  return (
    <Suspense fallback={<SplashScreen />}>
      <SubscriptionProvider>
        <PlanProvider>
          <ModalProvider>
            <AppRoutes />
          </ModalProvider>
          <ToastContainer />
        </PlanProvider>
      </SubscriptionProvider>
    </Suspense>
  );
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
